"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_classifier_service_client_js_1 = require("@synisys/idm-classifier-service-client-js");
var Observable_1 = require("rxjs/Observable");
var idm_entity_search_client_js_1 = require("@synisys/idm-entity-search-client-js");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
var idm_um_permission_client_js_1 = require("@synisys/idm-um-permission-client-js");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var idm_locale_service_client_js_1 = require("@synisys/idm-locale-service-client-js");
var custom_aggregate_functions_provider_service_1 = require("../../../../shared/services/api/summary-pages/custom-aggregate/custom-aggregate-functions-provider.service");
var overview_custom_calculation_fields_service_1 = require("../../../../shared/services/api/summary-pages/custom-calculation/overview-custom-calculation-fields.service");
var custom_aggregate_filtering_provider_service_1 = require("../../../../shared/services/api/summary-pages/custom-aggregate/custom-aggregate-filtering-provider.service");
var overview_custom_component_provider_service_1 = require("../../../../shared/services/api/summary-pages/custom-component/overview-custom-component-provider.service");
var operators_1 = require("rxjs/operators");
var overview_field_type_1 = require("../model/overview-field-type");
var overview_card_type_1 = require("../model/overview-card-type");
var root_category_provider_service_1 = require("../../../../shared/services/api/root-category-provider.service");
var idm_de_service_client_js_1 = require("@synisys/idm-de-service-client-js");
var OverviewHelperService = /** @class */ (function () {
    function OverviewHelperService(classifierService, entitySearchService, deService, kbService, sessionDataProvider, rootCategoryProviderService, localeService, _currentLanguageProvider, overviewCustomCalculationFieldsService, customAggregateFunctionsProviderService, customAggregateFilteringProviderService, overviewCustomComponentProviderService) {
        this.classifierService = classifierService;
        this.entitySearchService = entitySearchService;
        this.deService = deService;
        this.kbService = kbService;
        this.sessionDataProvider = sessionDataProvider;
        this.rootCategoryProviderService = rootCategoryProviderService;
        this.localeService = localeService;
        this._currentLanguageProvider = _currentLanguageProvider;
        this.overviewCustomCalculationFieldsService = overviewCustomCalculationFieldsService;
        this.customAggregateFunctionsProviderService = customAggregateFunctionsProviderService;
        this.customAggregateFilteringProviderService = customAggregateFilteringProviderService;
        this.overviewCustomComponentProviderService = overviewCustomComponentProviderService;
        this.format = {
            date: 'date',
            dateTime: 'dateTime',
            time: 'time'
        };
        this._currentLanguageId$ = this._currentLanguageProvider.getCurrentLanguage()
            .pipe(operators_1.map(function (language) { return language.getId(); }), operators_1.shareReplay(1));
    }
    OverviewHelperService.prototype.getEntitiesByRootInstanceId = function (categoryName, rootCategoryName, rootInstanceId, config) {
        return this.getEntitiesFilteredByRoot(categoryName, rootCategoryName, rootInstanceId, config);
    };
    OverviewHelperService.prototype.loadEntityCustomFields = function (entityCategoryName, overviewCardType) {
        if (overviewCardType) {
            return this.overviewCustomCalculationFieldsService
                && this.overviewCustomCalculationFieldsService.getCustomFields(entityCategoryName, overviewCardType);
        }
        return Observable_1.Observable.of([]);
    };
    OverviewHelperService.prototype.getWFStates = function (category) {
        var _this = this;
        return this.getMetaCategory(category).pipe(operators_1.switchMap(function (metaCategory) {
            var filterBuilder = new idm_de_core_frontend_1.FilterBuilder().is("WFProcessID", metaCategory.getWFProcessId());
            return _this.classifierService.loadClassifiersViewByFilter('WFState', filterBuilder.buildJson());
        }));
    };
    OverviewHelperService.prototype.getClassifierViews = function (classifierCategory, excludeValues) {
        var filterBuilder = new idm_de_core_frontend_1.FilterBuilder();
        if (excludeValues && excludeValues.length) {
            filterBuilder.and(new idm_de_core_frontend_1.FilterBuilder().not(new idm_de_core_frontend_1.FilterBuilder().in(idm_classifier_service_client_js_1.ClassifierView.VIEW_CLASSIFIER_FIELD_NAME_OF_ID, excludeValues).build()).build());
        }
        return this.classifierService.loadClassifiersView(classifierCategory);
    };
    OverviewHelperService.prototype.deserializeEntityForCard = function (configItem, data, categoryName) {
        var _this = this;
        var metaField;
        return this.kbService.getMetaFields(categoryName)
            .pipe(operators_1.switchMap(function (metaFields) {
            metaField = metaFields.find(function (field) { return field.getSystemName() === configItem.fieldName; });
            if (metaField && data && data.hasProperty(configItem.fieldName) && data.getProperty(configItem.fieldName).value) {
                switch (metaField.getType()) {
                    case idm_kb_service_client_js_1.MetaFieldType.WORKFLOW_STATE:
                    case idm_kb_service_client_js_1.MetaFieldType.CLASSIFIER: {
                        var classifier = data.getProperty(configItem.fieldName).value;
                        return _this.classifierService.getEntityName(metaField.getCompoundCategorySystemName(), classifier);
                    }
                    case idm_kb_service_client_js_1.MetaFieldType.MULTILINGUAL_STRING: {
                        return _this._currentLanguageId$.pipe(operators_1.map(function (currentLanguageId) {
                            if (data.getProperty(configItem.fieldName).value.getValue(currentLanguageId)) {
                                return data.getProperty(configItem.fieldName).value.getValue(currentLanguageId);
                            }
                            return null;
                        }));
                    }
                    case idm_kb_service_client_js_1.MetaFieldType.DATE: {
                        return _this.formatDate(data.getProperty(configItem.fieldName).value, 'date');
                    }
                    case idm_kb_service_client_js_1.MetaFieldType.DATE_TIME: {
                        return _this.formatDate(data.getProperty(configItem.fieldName).value, 'dateTime');
                    }
                    case idm_kb_service_client_js_1.MetaFieldType.MULTI_SELECT: {
                        return _this.loadMultiselectField(metaField, configItem, data);
                    }
                }
                return Observable_1.Observable.of(data.getProperty(configItem.fieldName).value);
            }
            return Observable_1.Observable.of(null);
        }), operators_1.switchMap(function (value) {
            return _this._currentLanguageId$.pipe(operators_1.map(function (currentLanguageId) {
                return {
                    title: metaField && metaField.getDisplayNameMultilingual() &&
                        metaField.getDisplayNameMultilingual().getValue(currentLanguageId),
                    value: value
                };
            }));
        }));
    };
    OverviewHelperService.prototype.sortOverviewCards = function (overviewItemsConfig) {
        overviewItemsConfig.sort(function (card1, card2) {
            if (card1.cardType.id === overview_card_type_1.OverviewCardType.MAIN_CARD) {
                return -1;
            }
            if (card1.orderId && card2.orderId) {
                return card1.orderId - card2.orderId;
            }
        });
    };
    // -------- HELPERS ------------------
    OverviewHelperService.prototype.loadMultiselectField = function (metaField, configItem, data) {
        var _this = this;
        var loadMetaCategory$ = this.kbService.getMetaCategoryByMetaCategoryId(new idm_kb_service_client_js_1.MetaCategoryId(metaField.getCompoundCategorySystemName()));
        return loadMetaCategory$.pipe(operators_1.switchMap(function (metaCategory) {
            var values = data.getProperty(configItem.fieldName).value || [];
            var names$ = [];
            if (metaCategory.getIsClassifier()) {
                values.forEach(function (value) { return names$.push(_this.classifierService.getEntityName(metaField.getCompoundCategorySystemName(), value)); });
            }
            else {
                values.forEach(function (value) { return names$.push(_this.deService.getEntityName(metaField.getCompoundCategorySystemName(), value, '/')); });
            }
            return names$.length ? Observable_1.Observable.zip.apply(Observable_1.Observable, names$).pipe(operators_1.map(function (stringValues) { return stringValues.join('; '); })) :
                Observable_1.Observable.of(null);
        }));
    };
    OverviewHelperService.prototype.getEntitiesFilteredByRoot = function (categoryName, rootCategoryName, rootInstanceId, config) {
        var _this = this;
        var rootMetaField$ = this.rootCategoryProviderService.getRootCategoryMetaField(categoryName);
        var categoryInstanceFields$ = this.kbService.getInstanceMetaField(categoryName);
        return Observable_1.Observable.zip(rootMetaField$, categoryInstanceFields$)
            .pipe(operators_1.switchMap(function (_a) {
            var rootMetaField = _a[0], instanceField = _a[1];
            var filterBuilder = new idm_de_core_frontend_1.FilterBuilder().is(rootMetaField && rootMetaField.getSystemName(), rootInstanceId);
            return _this.getParticipantFields(config, categoryName, rootCategoryName).pipe(operators_1.switchMap(function (participantFields) {
                return _this.entitySearchService.loadPortfolioItemsByFields(categoryName, new idm_de_core_frontend_1.PagingOptions(0, 1000), null, filterBuilder.buildJson(), null, [idm_um_permission_client_js_1.CategoryPermissionType.VIEW], participantFields.concat([instanceField && instanceField.getSystemName()]))
                    .pipe(operators_1.map(function (responseData) { return responseData.getData(); }));
            }));
        }));
    };
    OverviewHelperService.prototype.getParticipantFields = function (config, categoryName, rootCategoryName) {
        var aggregateFields = this.getContentFieldsOfType(config, overview_field_type_1.OverviewPortfolioFieldType.AGGREGATE);
        var calculationFields = this.getContentFieldsOfType(config, overview_field_type_1.OverviewPortfolioFieldType.CALCULATION);
        var componentFields = this.getContentFieldsOfType(config, overview_field_type_1.OverviewPortfolioFieldType.COMPONENT);
        var participants = [];
        config.contentFieldsWithLevels.forEach(function (level) {
            participants.push.apply(participants, level.data
                .filter(function (field) { return field.fieldName && field.overviewPortfolioFieldType === overview_field_type_1.OverviewPortfolioFieldType.FIELD
                && participants.indexOf(field.fieldName) === -1; }).map(function (field) { return field.fieldName; }));
        });
        aggregateFields.forEach(function (aggregateField) {
            if (config.cardType.id !== overview_card_type_1.OverviewCardType.GROUP_CARD && aggregateField.aggregateConfig.sourceField) {
                participants.push(aggregateField.aggregateConfig.sourceField);
            }
            else {
                aggregateField.aggregateConfig.groupingField &&
                    participants.push(aggregateField.aggregateConfig.groupingField);
                aggregateField.aggregateConfig.aggregateField &&
                    participants.push(aggregateField.aggregateConfig.aggregateField);
            }
        });
        var loadCalculations$ = calculationFields.length ?
            this.loadEntityCustomFields(categoryName, config.cardType.id)
                .pipe(operators_1.map(function (customFunctions) {
                return customFunctions ? customFunctions.filter(function (customFunction) {
                    return customFunction.participants && customFunction.participants.length
                        && calculationFields.find(function (field) { return field.fieldName === customFunction.key; });
                }) : [];
            }))
            : Observable_1.Observable.of([]);
        var loadComponents$ = calculationFields.length ?
            this.overviewCustomComponentProviderService.getCustomComponents(categoryName, rootCategoryName, config.cardType.id)
                .pipe(operators_1.map(function (customComponents) {
                return customComponents ? customComponents.filter(function (customComponent) {
                    return customComponent.participants && customComponent.participants.length
                        && componentFields.find(function (field) { return field.fieldName === customComponent.componentSelector; });
                }) : [];
            }))
            : Observable_1.Observable.of([]);
        return Observable_1.Observable.zip(loadCalculations$, loadComponents$).pipe(operators_1.map(function (_a) {
            var calculations = _a[0], components = _a[1];
            calculations.forEach(function (customFunction) { return participants.push.apply(participants, customFunction.participants); });
            components.forEach(function (component) { return participants.push.apply(participants, component.participants); });
            return participants;
        }));
    };
    OverviewHelperService.prototype.getContentFieldsOfType = function (config, overviewFieldType) {
        var fieldsOfType = [];
        config.contentFieldsWithLevels.forEach(function (level) {
            var levelCustomFields = level.data.filter(function (levelField) {
                return levelField.fieldName && levelField.overviewPortfolioFieldType === overviewFieldType;
            });
            if (levelCustomFields.length) {
                fieldsOfType.push.apply(fieldsOfType, levelCustomFields);
            }
        });
        return fieldsOfType;
    };
    OverviewHelperService.prototype.getMetaCategory = function (category) {
        return this.kbService.getMetaCategoryByMetaCategoryId(new idm_kb_service_client_js_1.MetaCategoryId(category));
    };
    OverviewHelperService.prototype.formatDate = function (date, format) {
        var _this = this;
        if (format === void 0) { format = this.format.dateTime; }
        if (date == null) {
            return null;
        }
        var timestamp = (typeof date !== 'number' && typeof date !== 'string') ? date.getTime() : +date;
        switch (format) {
            case this.format.date:
                return this._currentLanguageId$.pipe(operators_1.switchMap(function (currentLanguageId) {
                    return Observable_1.Observable.from(_this.localeService.formatDate(timestamp, currentLanguageId));
                }));
            case this.format.dateTime:
                return this._currentLanguageId$.pipe(operators_1.switchMap(function (currentLanguageId) {
                    return Observable_1.Observable.from(_this.localeService.formatDateTime(timestamp, currentLanguageId));
                }));
            case this.format.time:
                return this._currentLanguageId$.pipe(operators_1.switchMap(function (currentLanguageId) {
                    return Observable_1.Observable.from(_this.localeService.formatTime(timestamp, currentLanguageId));
                }));
        }
    };
    OverviewHelperService = __decorate([
        core_1.Injectable(),
        __param(8, core_1.Optional()),
        __param(9, core_1.Optional()),
        __param(10, core_1.Optional()),
        __param(11, core_1.Optional()),
        __metadata("design:paramtypes", [idm_classifier_service_client_js_1.ClassifierService,
            idm_entity_search_client_js_1.EntitySearchService,
            idm_de_service_client_js_1.DeService,
            idm_kb_service_client_js_1.KbService,
            idm_session_data_provider_api_js_1.SessionDataProvider,
            root_category_provider_service_1.RootCategoryProviderService,
            idm_locale_service_client_js_1.LocaleService,
            idm_session_data_provider_api_js_1.CurrentLanguageProvider,
            overview_custom_calculation_fields_service_1.OverviewCustomCalculationFieldsService,
            custom_aggregate_functions_provider_service_1.CustomAggregateFunctionsProviderService,
            custom_aggregate_filtering_provider_service_1.CustomAggregateFilteringProviderService,
            overview_custom_component_provider_service_1.OverviewCustomComponentProviderService])
    ], OverviewHelperService);
    return OverviewHelperService;
}());
exports.OverviewHelperService = OverviewHelperService;
//# sourceMappingURL=overview-helper.service.js.map